import { defineFcm } from '../shared/factory';

export const FCM_PAYPAL_MOBILE_DEFAULT = defineFcm('paypal_mobile_default').asBoolean().withDefault(false).toConfig();
